import { jsx as _jsx } from "react/jsx-runtime";
import { ConversationTextualMessage } from '../../textualMessage/conversationTextualMessage';
/** Represents the component for displaying a conversation textual event group. */
export const ConversationTextualEventGroup = ({ author, className, events, hideAttachments, hideGutterActions, }) => {
    const timestamp = events[events.length - 1].created_at;
    return (_jsx(ConversationTextualMessage, Object.assign({ className: className, author: author, timestamp: timestamp, hideGutterActions: hideGutterActions, variant: events[0].direction === 'outbound'
            ? 'textualOutbound'
            : 'textualInbound' }, { children: _jsx(ConversationTextualMessage.Events, { events: events, hideAttachments: hideAttachments }) })));
};
